import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

const LEGACY_SCORE_OPTIONS = [
  {
    id: "PASS",
    name: "Pass",
  },
  {
    id: "WARN",
    name: "Warn",
  },
  {
    id: "FAIL",
    name: "Fail",
  },
  {
    id: "CLEARED",
    name: "Clear",
  },
  {
    id: "REVIEW",
    name: "Review",
  },
  {
    id: "NA",
    name: "N/A",
  },
  {
    id: "DIDNOTPASS",
    name: "Did Not Pass",
  },
  {
    id: "NONE",
    name: "None",
  },
];

export function LegacyScoreFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();

  return (
    <Picker
      showActionBar
      selectedKeys={params.score?.split(",") || []}
      onSelectionChange={(keys) => setParam("score", Array.from(keys))}
      label={t("Score")}
      items={LEGACY_SCORE_OPTIONS}
      selectionMode="multiple"
      testID="legacy-score-filter"
    />
  );
}
